import React from "react";
import "./WorkoutImageModal.css";

const WorkoutImageModal = ({ 
  isVisible, 
  imageUrl, 
  workoutName, 
  onClose 
}) => {
  if (!isVisible) return null;

  return (
    <div className="workout-image-modal-overlay" onClick={onClose}>
      <div className="workout-image-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="workout-image-modal-header">
          <h3>{workoutName}</h3>
          <button className="workout-image-modal-close" onClick={onClose}>
            <i className="fa-solid fa-times"></i>
          </button>
        </div>
        <div className="workout-image-modal-body">
          <img 
            src={imageUrl} 
            alt={workoutName} 
            className="workout-image-large"
          />
        </div>
      </div>
    </div>
  );
};

export default WorkoutImageModal;
